/**
 * Opal & Charlie — Collection Page JS
 * File: assets/oac-collection.js
 *
 * Handles:
 * - "Buy Now" redirect from collection card → product page
 *   (redirects to product URL; product page JS detects ?buy_now=true
 *   and auto-triggers the accelerated checkout flow)
 * - Active state on alt-nav links based on current URL
 */

(function () {
  'use strict';

  /* ── BUY NOW — redirect to product page ─────────────────── */
  //
  // Because customers haven't selected a length yet, "Buy Now" on a
  // collection card can't add directly to cart. Instead we redirect to
  // the product page with ?buy_now=true so the product page JS can
  // open the accelerated checkout as soon as a variant is selected.
  //
  // The product page JS (oac-product.js) listens for this param:
  //   if (?buy_now=true) → after first variant selection, auto-submit
  //   the Buy Now form rather than waiting for the button click.

  // const buyNowBtns = document.querySelectorAll('.oac-coll-card__buy-now[data-product-url]');

  // buyNowBtns.forEach(btn => {
  //   btn.addEventListener('click', function (e) {
  //     e.preventDefault();
  //     const url = new URL(this.dataset.productUrl, window.location.origin);
  //     url.searchParams.set('buy_now', 'true');
  //     window.location.href = url.toString();
  //   });
  // });

  const buyNowBtns = document.querySelectorAll('.oac-btn-buy-now');

  buyNowBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const form = btn.closest('.oac-product-form');
      if (!form) return;

      // Create a hidden input to signal accelerated checkout
      const input   = document.createElement('input');
      input.type    = 'hidden';
      input.name    = 'return_to';
      input.value   = '/checkout';
      form.appendChild(input);
      form.submit();
    });
  })


  /* -- Length selectors -- */
  const lengthButtons = document.querySelectorAll('.oac-coll-card__len');
  function selectVariant(btn) {
    lengthButtons.forEach(b => b.classList.remove('selected'));
    btn.classList.add('selected');

    const price = btn.dataset.price
    const variantId = btn.dataset.variantId

    btn.closest(".oac-coll-card__body").querySelector('.oac-coll-card__price').innerText = price

    //Updating ID
    const form = btn.closest(".oac-coll-card__body").querySelector('.oac-product-form');
    if(form){
      form.querySelector('form [name="id"]').value = variantId
    }
  }
  lengthButtons.forEach(btn => {
    btn.addEventListener('click', () => selectVariant(btn));
  });


  /* ── ALT NAV — active state ─────────────────────────────── */

  const altLinks  = document.querySelectorAll('.oac-alt-nav__link');
  const currentPath = window.location.pathname.replace(/\/$/, '');

  altLinks.forEach(link => {
    const linkPath = new URL(link.href, window.location.origin)
      .pathname.replace(/\/$/, '');
    if (linkPath === currentPath) {
      link.setAttribute('aria-current', 'true');
    }
  });


  /* ── NOTIFY ME — email capture ──────────────────────────── */
  //
  // "Get Notified" links on coming-soon cards.
  // If a Klaviyo back-in-stock form is installed, target it here.
  // Default behavior: scroll to a notify form or open a modal.
  // Fallback: redirect to a /pages/notify page.

  const notifyBtns = document.querySelectorAll('.oac-coll-card__notify-btn');

  notifyBtns.forEach(btn => {
    btn.addEventListener('click', function (e) {
      const productHandle = this.dataset.productHandle;

      // If Klaviyo BIS is installed, trigger it
      if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
        e.preventDefault();
        window.klaviyo.openForm(this.dataset.klaviyoFormId || '');
        return;
      }

      // Fallback: navigate to notify page with product context
      const notifyUrl = '/pages/notify?product=' + (productHandle || '');
      window.location.href = notifyUrl;
    });
  });

})();
